/* MTD Product buy box — gallery, bundle tiers, subscription, add to cart. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.mtdReady === 'true') return;
    root.dataset.mtdReady = 'true';

    /* ---------- Gallery ---------- */
    var images = root.querySelectorAll('[data-mtd-media]');
    var thumbs = root.querySelectorAll('[data-mtd-thumb]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.dataset.mtdThumb;
        images.forEach(function (img) {
          img.classList.toggle('is-active', img.dataset.mtdMedia === index);
        });
        thumbs.forEach(function (t) {
          var on = t === thumb;
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
      });
    });

    /* ---------- Purchase options ---------- */
    var form = root.querySelector('form');
    var variantInput = root.querySelector('[data-mtd-variant]');
    var quantityInput = root.querySelector('[data-mtd-quantity]');
    var planInput = root.querySelector('[data-mtd-plan]');
    var options = root.querySelectorAll('[data-mtd-plan-option]');
    var freq = root.querySelector('[data-mtd-freq-select]');
    var selected = null;

    function priceOf(input) {
      // With a frequency chosen, that plan's price wins over the default.
      if (input && input.dataset.plan && freq) {
        var opt = freq.options[freq.selectedIndex];
        if (opt && opt.dataset.price) return opt.dataset.price;
      }
      return input ? input.dataset.price : '';
    }

    function apply(input) {
      selected = input;
      var plan = input.dataset.plan;

      if (plan && freq) plan = freq.value || plan;

      if (planInput) {
        planInput.value = plan || '';
        planInput.disabled = !plan;
      }

      options.forEach(function (o) {
        o.classList.toggle('is-selected', o.contains(input));
      });

      var price = priceOf(input);
      var cta = root.querySelector('[data-mtd-cta-price]');
      if (cta && price) cta.textContent = price.trim();

      document.dispatchEvent(new CustomEvent('mtd:tier:change', {
        detail: {
          variant: variantInput ? variantInput.value : '',
          quantity: quantityInput ? quantityInput.value : '1',
          plan: plan || '',
          price: price,
          label: input.closest('[data-mtd-plan-option]')
            ? (input.closest('[data-mtd-plan-option]').querySelector('.mtd-buybox__plan-label') || {}).textContent
            : ''
        }
      }));
    }

    options.forEach(function (opt) {
      var input = opt.querySelector('[data-mtd-plan-input]');
      if (!input) return;
      if (input.checked) apply(input);
      input.addEventListener('change', function () { if (input.checked) apply(input); });
    });

    if (freq) {
      freq.addEventListener('change', function () {
        // Choosing a frequency implies the subscription option.
        var subInput = root.querySelector('[data-mtd-plan-input][data-plan]:not([data-plan=""])');
        if (subInput && !subInput.checked) subInput.checked = true;
        var priceEl = root.querySelector('[data-mtd-sub-price]');
        var opt = freq.options[freq.selectedIndex];
        if (priceEl && opt && opt.dataset.price) priceEl.textContent = opt.dataset.price;
        if (subInput) apply(subInput);
      });
      // Keep the dropdown from toggling the radio it sits inside.
      freq.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
    }

    /* ---------- Add to cart ---------- */
    if (!form) return;

    // Extras that ride along with the main product.
    function includedItems() {
      var out = [];
      root.querySelectorAll('[data-mtd-included-variant]').forEach(function (el) {
        var id = Number(el.dataset.mtdIncludedVariant);
        if (id) out.push({ id: id, quantity: Number(el.dataset.mtdIncludedQty) || 1 });
      });
      return out;
    }

    // With a bundle or upsell app installed, that app owns the button. Binding
    // our own handler too would add the product twice.
    if (root.dataset.bundleApp === 'true') return;

    form.addEventListener('submit', function (event) {
      var code = '';
      var extras = includedItems();

      // With nothing extra to do and no drawer to open, the native form POST is
      // fine — add-to-cart still works if this script fails to load.
      var hasDrawer = !!document.querySelector('[data-mtd-cart]');
      if (!code && !extras.length && !hasDrawer) return;

      event.preventDefault();

      var button = root.querySelector('[data-mtd-add]');
      var label = root.querySelector('[data-mtd-cta-text]');
      var original = label ? label.textContent : '';
      if (button) button.disabled = true;
      if (label) label.textContent = 'Adding…';

      var main = {
        id: Number(variantInput.value),
        quantity: Number(quantityInput.value)
      };
      if (planInput && !planInput.disabled && planInput.value) {
        main.selling_plan = Number(planInput.value);
      }

      // One request adds the product and everything included with it, so the
      // cart never ends up half-filled if a later call fails.
      var payload = { items: [main].concat(extras) };
      // Ask for the drawer markup in the same response so the cart opens on
      // fresh content instead of the state it had at page load.
      if (window.MTDCart) payload.sections = 'mtd-cart-drawer';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (err) { throw err; });
          return response.json();
        })
        .then(function (data) {
          if (code) {
            // Applying a discount to the cart session requires a navigation.
            window.location.href =
              window.Shopify.routes.root + 'discount/' + encodeURIComponent(code) +
              '?redirect=' + encodeURIComponent(window.Shopify.routes.root + 'cart');
            return;
          }

          // Slide the cart open rather than leaving the page — but only if the
          // theme's drawer is actually present. A cart app may have replaced it.
          if (window.MTDCart && document.querySelector('[data-mtd-cart]')) {
            if (button) button.disabled = false;
            if (label) label.textContent = original;

            // Paint from this response if it carried the markup; otherwise
            // fetch it, and only open once the content is actually in place.
            if (window.MTDCart.render(data)) {
              window.MTDCart.open();
            } else {
              window.MTDCart.openWithRefresh();
            }
            return;
          }
          window.location.href = window.Shopify.routes.root + 'cart';
        })
        .catch(function (err) {
          if (button) button.disabled = false;
          if (label) label.textContent = original;

          // An included product being sold out must not block the sale — retry
          // with the main product on its own.
          if (extras.length) {
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(main)
            }).then(function () {
              window.location.href = window.Shopify.routes.root + 'cart';
            }).catch(function () { form.submit(); });
            return;
          }
          form.submit(); // last resort: native POST
        });
    });
  }

  /* Optional: put the code in the shopper's basket so checkout already has it.
     Runs once per session — re-applying on every page load would fight anyone
     who deliberately removed it. */
  function applyDiscount() {
    var banner = document.querySelector('[data-mtd-autodiscount]');
    if (!banner) return;
    var code = banner.dataset.mtdAutodiscount;
    if (!code) return;

    var key = 'mtd-discount-' + code;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');

    fetch(window.Shopify.routes.root + 'discount/' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'same-origin'
    }).catch(function () {
      // A failed apply must never block the page; the banner still shows the
      // code so the shopper can enter it at checkout.
    });
  }

  /* Optional city lookup for the delivery bar. Off unless the merchant asks
     for it. The bar already renders a correct sentence without the city, so a
     blocked or failed request changes nothing the shopper sees. */
  function fillCity() {
    var bar = document.querySelector('[data-mtd-geo][data-geo-lookup="true"]');
    if (!bar) return;
    var target = bar.querySelector('[data-mtd-geo-text]');
    if (!target) return;

    var cached = sessionStorage.getItem('mtd-geo-city');
    function paint(city) {
      if (!city) return;
      var line = bar.dataset.geoTemplate || '';
      line = line
        .replace('[date]', bar.dataset.geoDate || '')
        .replace('[country]', bar.dataset.geoCountry || '')
        .replace('[city]', city);
      target.textContent = line;
    }

    if (cached) return paint(cached);

    fetch('https://ipapi.co/json/')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var city = d && d.city;
        if (!city) return;
        sessionStorage.setItem('mtd-geo-city', city);
        paint(city);
      })
      .catch(function () { /* leave the city-free sentence in place */ });
  }

  function boot() {
    document.querySelectorAll('[data-mtd-buybox]').forEach(init);
    applyDiscount();
    fillCity();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Re-init after theme editor re-renders the section.
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-mtd-buybox]').forEach(init);
  });
})();
